import React, { Component } from 'react';
import { connect } from 'react-redux';
import clone from 'lodash/clone';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import {
    getStudentsByUserId,
    openUnAssignStudentsModal,
    unassignStudentsUsingClassId,
    editStudent,
    closeEditStudentValidationModal,
    refreshStudentListOnCancel,
    showHideModal
} from './actions';
import { printSignInCard } from '../student-roll/actions';
import EditStudent from '../../components/edit-student-form';

export class EditStudents extends Component {
    static propTypes = {
        selectedProduct: PropTypes.object,
        match: PropTypes.object.isRequired,
        editStudentDetail: PropTypes.object,
        openUnAssignStudentsModal: PropTypes.func,
        unassignStudentsUsingClassId: PropTypes.func,
        getStudentsByUserId: PropTypes.func,
        isUnassignedModalOpen: PropTypes.bool,
        unassignDisableButton: PropTypes.bool,
        isLoadingEditStudentDetail: PropTypes.bool,
        editStudent: PropTypes.func,
        dataFilterOption: PropTypes.object,
        studentDetail: PropTypes.object,
        updatingStudent: PropTypes.bool,
        showEditStudentValidationModal: PropTypes.bool,
        editStudentValidationMessage: PropTypes.string,
        closeEditStudentValidationModal: PropTypes.func,
        printSignInCard: PropTypes.func,
        isSignInCardDownloaded: PropTypes.bool,
        refreshStudentListOnCancel: PropTypes.func,
        showHideModal: PropTypes.func,
        showModal: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.handleOnUnassignStudentUsingClassId = this.handleOnUnassignStudentUsingClassId.bind(this);
        this.handleOnUnassignConfirm = this.handleOnUnassignConfirm.bind(this);
        this.handleOnCloseModal = this.handleOnCloseModal.bind(this);
        this.unassignStudentsSuccessConfirmation = this.unassignStudentsSuccessConfirmation.bind(this);
        this.handleOnDownSignInCards = this.handleOnDownSignInCards.bind(this);
        this.state = { showUnassignStudentModal: false, refreshListOnCancel: false };
    }

    static contextTypes = {
        router: PropTypes.object
    }

    componentDidMount() {
        this.props.getStudentsByUserId(this.props.selectedProduct.id, this.props.match.params.id);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isSignInCardDownloaded !== this.props.isSignInCardDownloaded) {
            setTimeout(this.props.showHideModal(false), 1000);
        }
    }

    handleOnUnassignStudentUsingClassId = (classId) => {
        this.setState({ showUnassignStudentModal: true, classId });
        this.props.openUnAssignStudentsModal();
    };

    handleOnUnassignConfirm = () => {
        this.props.unassignStudentsUsingClassId(this.props.editStudentDetail.userProfileId, this.state.classId);
    }

    handleOnCloseModal = () => {
        this.setState({ showUnassignStudentModal: false });
        this.props.showHideModal(false);
    }

    unassignStudentsSuccessConfirmation =() => {
        this.handleOnCloseModal();
        this.setState({ refreshListOnCancel: true });
        this.props.getStudentsByUserId(this.props.selectedProduct.id, this.props.match.params.id);
    }

    handleOnEditStudentSubmit = () => {
        const student = clone(this.props.studentDetail);
        student.yearGroup = parseInt(student.yearGroupEnum, 10);
        this.props.editStudent(student, true, this.context);
    }

    handleOnCloseEditStudentValidationModal = () => {
        this.props.closeEditStudentValidationModal();
    }

    handleOnCloseEditStudent = () => {
        this.context.router.history.push('/students');
        if (this.state.refreshListOnCancel === true) {
            this.props.refreshStudentListOnCancel();
        }
    }

    handleOnPrintSignInCard = (format) => {
        const studentSignInCardData = { studentUserProfileIds: [this.props.match.params.id],
            SignInCardPageSizeType: format };
        this.props.printSignInCard(this.props.selectedProduct.id, studentSignInCardData);
    }

    handleOnAssignClass = () => {
        const assignType = 'classToStudent';
        this.context.router.history.push(`/assign-user/${this.props.match.params.id}/${assignType}`);
    }

    handleOnDownSignInCards = () => {
        this.props.showHideModal(true);
    }

    render() {
        return (<div>
            <EditStudent
                closeEditStudent={this.handleOnCloseEditStudent}
                closeEditStudentValidationModal={this.handleOnCloseEditStudentValidationModal}
                dataFilterOptions={this.props.dataFilterOption}
                displayNewCourses={this.displayNewCourses}
                downloadStudentsSignInCards={this.handleOnDownSignInCards}
                editStudentDetail={this.props.editStudentDetail}
                editStudentValidationMessage={this.props.editStudentValidationMessage}
                handleOnAssignClass={this.handleOnAssignClass}
                handleOnCloseModal={this.handleOnCloseModal}
                handleOnEditStudentSubmit={this.handleOnEditStudentSubmit}
                handleOnPrintSignInCard={this.handleOnPrintSignInCard}
                handleOnUnassignConfirm={this.handleOnUnassignConfirm}
                handleOnUnassignStudent={this.handleOnUnassignStudentUsingClassId}
                isLoading={this.props.unassignDisableButton}
                isLoadingEditStudentDetail={this.props.isLoadingEditStudentDetail}
                isSignInCardDownloaded={this.props.isSignInCardDownloaded}
                isUnassignedModalOpen={this.props.isUnassignedModalOpen}
                productName={this.props.selectedProduct.name}
                showEditStudentValidationModal={this.props.showEditStudentValidationModal}
                showModal={this.props.showModal}
                showUnassignStudentModal={this.state.showUnassignStudentModal}
                student={this.props.studentDetail}
                unassignStudentsSuccessConfirmation={this.unassignStudentsSuccessConfirmation}
                updatingStudent={this.props.updatingStudent}
            />
        </div>);
    }
}

const mapStateToProps = state => ({
    dataFilterOption: state.studentRoll.dataFilterOption,
    selectedProduct: state.product,
    editStudentsReducer: state.editStudentsReducer,
    editStudentDetail: state.editStudent.editStudentDetail,
    isUnassignedModalOpen: state.editStudent.isUnassignedModalOpen,
    unassignDisableButton: state.editStudent.unassignDisableButton,
    isLoadingEditStudentDetail: state.editStudent.isLoadingEditStudentDetail,
    studentDetail: state.editStudent.studentDetail,
    updatingStudent: state.editStudent.updatingStudent,
    showEditStudentValidationModal: state.editStudent.showEditStudentValidationModal,
    editStudentValidationMessage: state.editStudent.editStudentValidationMessage,
    isSignInCardDownloaded: state.studentRoll.isSignInCardDownloaded,
    showModal: state.editStudent.showModal
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getStudentsByUserId,
        editStudent,
        openUnAssignStudentsModal,
        unassignStudentsUsingClassId,
        refreshStudentListOnCancel,
        closeEditStudentValidationModal,
        printSignInCard,
        showHideModal
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EditStudents);



// WEBPACK FOOTER //
// ./app/containers/edit-student/index.js